<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
        >
        <h3 class="text-decoration-underline input-text-size">Forte Credentials:</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            class=" input-text-size"
            v-model="editItem.apiAccessId"
            label="Forte API Access ID"
            required
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            class=" input-text-size"
            v-model="editItem.apiSecureId"
            label="Forte API Secure Key"
            required
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            class=" input-text-size"
            v-model="editItem.odTrustLocationId"
            label="OD Trusts Location ID"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="9"
        >
        <h3 class="text-decoration-underline input-text-size">Payrix Configuration:</h3>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
        <h3 class="text-decoration-underline input-text-size">Active Payment Gateway:</h3>
        </v-col>
      </v-row>
      <v-row>
         <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            class=" input-text-size"
            v-model="editItem.payrixApiKey"
            label="Payrix Public API Key"
            required
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            class=" input-text-size"
            v-model="editItem.payrixMerchentId"
            label="Payrix Merchant ID"
            required
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            class=" input-text-size"
            v-model="editItem.payrixPrivateKey"
            label="Payrix Private API Key"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12"
          md="3"
        >
        <v-radio-group v-model="editItem.selectedGateway" @change="handleGateway" row>
           <v-radio
              class=" input-text-size"
              label="Payrix"
              value="payrix"
            ></v-radio>
            <v-radio
              class=" input-text-size"
              label="Forte Pay"
              value="forte-pay"
            ></v-radio>
            <v-radio
              class=" input-text-size"
              label="Forte2"
              value="forte2"
            ></v-radio>
        </v-radio-group>

        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            class=" input-text-size"
            v-model="editItem.payrixEntityId"
            label="Payrix Entity ID"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
        >
        <h3 class="text-decoration-underline input-text-size">Forte2 Credentials (used for OD, Tax, Misc, Mtg):</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            class=" input-text-size"
            v-model="editItem.forte2ApiAccessId"
            label="Forte2 API Access ID"
            required
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            class=" input-text-size"
            v-model="editItem.forte2ApiSecureKey"
            label="Forte2 API Secure Key"
            required
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            class=" input-text-size"
            v-model="editItem.forte2BaseUrl"
            label="Forte2 Base URL"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            class=" input-text-size"
            v-model="editItem.forte2OrgId"
            label="Forte2 Merchant Org ID"
            hint="This county's org (org_XXXXXX)"
            persistent-hint
            required
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <!-- Partner org (WHO IS ACTING) — goes in the auth header, while the
               merchant org above (WHO IS BEING ACTED UPON) goes in the URI path.
               Optional on purpose: existing configs have only the merchant org,
               and the backend falls back to it when this is blank. -->
          <v-text-field
            class=" input-text-size"
            v-model="editItem.forte2AuthOrgId"
            label="Forte2 Partner Org ID"
            hint="ReNewGov partner org (org_XXXXXX). Blank = use Merchant Org ID."
            persistent-hint
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            class=" input-text-size"
            v-model="editItem.forte2LocId"
            label="Forte2 Location ID"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
        >
        <h3 class="text-decoration-underline input-text-size">Transaction Configuration:</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-checkbox
            class=" input-text-size"
            v-model="editItem.unregisteredDep"
            label="Enable Unregistered Deposits"
          ></v-checkbox>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-checkbox
            class=" input-text-size"
            v-model="editItem.usedLastRegister"
            label="Enable Last Used Registration Date"
          ></v-checkbox>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
        <v-checkbox
          class=" input-text-size"
          v-model="editItem.registrationNumber"
          label="Edit Registration Number"
          v-if="isAdminUser"
        ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-checkbox
          class=" input-text-size"
          v-model="editItem.voucherNumber"
          label="Edit Voucher Number"
          v-if="isAdminUser"
        ></v-checkbox>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            class=" input-text-size"
            v-model.number="editItem.durationOfCorrection"
            label="Duration of Correction(in Days)"
            type="number"
            ref="odConfigDurationOfCorrection"
            v-if="isAdminUser"
            :rules="durationValidation"
          ></v-text-field>
        </v-col>
        <v-checkbox
          class=" input-text-size ml-4 mt-8"
          v-model="editItem.isBnakOverrideOption"
          label="Bank Override Option"
        ></v-checkbox>
      </v-row>

      <v-row>
        <v-col
          cols="12"
        >
        <h3 class="text-decoration-underline input-text-size">Reconciliation Configuration:</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-checkbox
            class=" input-text-size"
            v-model="editItem.ccReconciliation"
            label="Enable CC Reconciliation"
          ></v-checkbox>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-checkbox
            class=" input-text-size"
            v-model="editItem.cashCheckReconciliation"
            label="Enable Cash/Check Reconciliation"
          ></v-checkbox>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-checkbox
            class=" input-text-size"
            v-model="editItem.trustReconciliation"
            label="Enable Trust Reconciliation"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-checkbox
            class=" input-text-size"
            v-model="editItem.enableODPostivePayBank"
            label="Enable Positive Pay Bank Account"
          ></v-checkbox>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-checkbox
            class=" input-text-size"
            id="odSettingHideDrawnBy"
            v-model="editItem.hideDrawnBy"
            label="Hide 'Drawn by' field"
          ></v-checkbox>
        </v-col>

        <v-col cols="12" md="4">
          <v-checkbox
            class=" input-text-size"
            id="odSettingUseRateToCalculateInterest"
            v-model="editItem.useRateToCalculateInterest"
            label="Use Rate To Calculate Interest"
          ></v-checkbox>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h3 class="text-decoration-underline input-text-size">OD File Import Configuration:</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-checkbox
            class="input-text-size"
            id="odSettingAllowImpWithSeqErrInOD"
            v-model="editItem.allowImpWithSeqErrInOD"
            label="Allow to proceed import with sequence error in OD file imports"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
        >
        <h3 class="text-decoration-underline input-text-size">Print Settings:</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-checkbox
            class=" input-text-size"
            v-model="editItem.hideMicrAcctLineOnVoucher"
            label="Hide MICR/Acct line on voucher"
          ></v-checkbox>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-checkbox
            class=" input-text-size"
            v-model="editItem.cashOnlyDepositSlip"
            label="Cash only deposit slip "
          ></v-checkbox>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-checkbox
            class=" input-text-size"
            v-model="editItem.hideForWhatOnVoucher"
            label="Hide For What on Voucher"
          ></v-checkbox>
        </v-col>
        <v-col cols="4" md="3">
          <v-checkbox
            class=" input-text-size"
            v-model="editItem.alternateVoucherFormat"
            label="Alternate Voucher format"
          ></v-checkbox>
        </v-col>
        <v-col
          cols="4" md="3">
          <v-checkbox
            class=" input-text-size"
            v-model="editItem.signatureLine"
            label="Print 2 signature lines"
          ></v-checkbox>
        </v-col>
        <v-col cols="4" md="3">
          <v-checkbox
            class=" input-text-size"
            v-model="editItem.prefillTreasurerSignature"
            label="Pre-fill Treasurer Signature"
          ></v-checkbox>
        </v-col>
        <v-col cols="4" md="3">
          <v-checkbox
            class=" input-text-size"
            v-model="editItem.pritnedByLine"
            label="`Printed by` line on vouchers"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          id="odSettingSaveBtn"
          depressed
          color="primary"
          @click="update"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
import { isAuthorised } from '../../store/auth/token';
import { cloneItem } from '../../util/shared/vue-global';

export default {
  data: () => ({
    originalOdSetting: null,
  }),
  computed: {
    editItem() {
      return this.$store.state.SystemConfig.odSettingItem || {};
    },
    durationValidation() {
      return [
        (value) => {
          if (value === '' || value === undefined) {
            return true;
          }
          if (!Number.isInteger(value)) {
            return 'Invalid correction day!';
          }
          if (parseFloat(value) <= 1) {
            return 'Invalid correction day!';
          }
          return true;
        },
      ];
    },
    isAdminUser() {
      // Text field's visibility won't change if user logs in and logs out in OD settings.
      return isAuthorised(['ODAdministration']);
    },
  },
  async created() {
    await this.$store.dispatch(
      'SystemConfig/loadConfig',
      { requiredScope: 'odconfig' },
    );
    this.originalOdSetting = cloneItem(this.buildOdConfigItem());
  },
  methods: {
    buildOdConfigItem() {
      const settingItem = this.editItem;
      /* When you will update any new field in the OD setting,
        you need to add the field here. */
      return {
        id: settingItem.id,
        apiAccessId: settingItem.apiAccessId,
        apiSecureId: settingItem.apiSecureId,
        odTrustLocationId: settingItem.odTrustLocationId,
        payrixApiKey: settingItem.payrixApiKey,
        payrixMerchentId: settingItem.payrixMerchentId,
        payrixEntityId: settingItem.payrixEntityId,
        payrixPrivateKey: settingItem.payrixPrivateKey,
        forte2ApiAccessId: settingItem.forte2ApiAccessId,
        forte2ApiSecureKey: settingItem.forte2ApiSecureKey,
        forte2BaseUrl: settingItem.forte2BaseUrl,
        forte2OrgId: settingItem.forte2OrgId,
        forte2AuthOrgId: settingItem.forte2AuthOrgId,
        forte2LocId: settingItem.forte2LocId,
        selectedGateway: settingItem.selectedGateway,
        unregisteredDep: settingItem.unregisteredDep,
        usedLastRegister: settingItem.usedLastRegister,
        registrationNumber: settingItem.registrationNumber,
        voucherNumber: settingItem.voucherNumber,
        durationOfCorrection: settingItem.durationOfCorrection,
        isBnakOverrideOption: settingItem.isBnakOverrideOption,
        ccReconciliation: settingItem.ccReconciliation,
        cashCheckReconciliation: settingItem.cashCheckReconciliation,
        trustReconciliation: settingItem.trustReconciliation,
        enableODPostivePayBank: settingItem.enableODPostivePayBank,
        hideDrawnBy: settingItem.hideDrawnBy,
        useRateToCalculateInterest: settingItem.useRateToCalculateInterest,
        hideMicrAcctLineOnVoucher: settingItem.hideMicrAcctLineOnVoucher,
        cashOnlyDepositSlip: settingItem.cashOnlyDepositSlip,
        hideForWhatOnVoucher: settingItem.hideForWhatOnVoucher,
        alternateVoucherFormat: settingItem.alternateVoucherFormat,
        signatureLine: settingItem.signatureLine,
        prefillTreasurerSignature: settingItem.prefillTreasurerSignature,
        pritnedByLine: settingItem.pritnedByLine,
        allowImpWithSeqErrInOD: settingItem.allowImpWithSeqErrInOD,
      };
    },
    async update() {
      const result = this.$refs.odConfigDurationOfCorrection.validate();
      if (result && window.confirm('Are you sure want to update this configuration?')) {
        const payload = {
          calledScope: 'odconfig',
          item: this.buildOdConfigItem(),
          previousItem: this.originalOdSetting,
          isLogAudit: true,
        };
        const ok = await this.$store.dispatch('SystemConfig/updateConfig', payload);
        if (ok) {
          this.originalOdSetting = cloneItem(this.buildOdConfigItem());
        }
      }
    },
    handleGateway(value) {
      this.editItem.selectedGateway = value;
    },
  },
};
</script>
